export enum Configs {
    ONBOARDING_WIZARD = "onboarding_wizard",
    ONBOARDING_TEST_EMAIL = "onboarding_test_email",
    BETA_FLAG_SYNC = "beta_flag_sync",
    CONFIG_GOOGLE_MAPS_API = "googlemaps_key",
    PLUGIN_GOOGLE_MAPS_API = "plugin_googlemaps_key",
    CONFIG_APP_VERSION = "mobile_app_version",
    IPSTACK_KEY = "ipstack_key",
    GOOGLE_APPLICATION_CREDENTIALS = "GOOGLE_APPLICATION_CREDENTIALS",
    GOOGLE_CLOUD_PROJECT_ID = "GOOGLE_CLOUD_PROJECT_ID",
    GOOGLE_CLOUD_MEDIA_BUCKET = "GOOGLE_CLOUD_MEDIA_BUCKET",
    GOOGLE_CLOUD_SUBSCRIPTION = "GOOGLE_CLOUD_SUBSCRIPTION",
    OPENAI_TOKEN = "OPENAI_TOKEN",
    GMB_OAUTH2_CLIENT_ID = "gmb_client_id",
    GMB_OAUTH2_CLIENT_SECRET = "gmb_client_secret",
    GMB_OAUTH2_REDIRECTS = "gmb_redirect_url",
    FACEBOOK_APP_ID = "facebook_app_id",
    FACEBOOK_APP_SECRET = "facebook_app_secret",
    FACEBOOK_CONFIG_ID = "facebook_config_id",
    LV_REPORT_URL = "lv_report_url",
    USE_SENTRY = "use_sentry",
    SENTRY_ENVIRONMENT = "sentry_environment",
    SENDGRID_KEY = "SENDGRID_KEY",
    SENDGRID_WEBHOOK_PUBLIC_KEY = "SENDGRID_WEBHOOK_PUBLIC_KEY",
    SENDGRID_CONFIGS = "SENDGRID_CONFIGS",
    WEB_NOTIFICATION_PUBLIC_KEY = "web_notification_public_key",
    WEB_NOTIFICATION_PRIVATE_KEY = "web_notification_private_key",
    MIGRATE_LAST_REVIEW_ID = "migrate_last_review_id",
    MIGRATE_LAST_CHECKIN_ID = "migrate_last_checkin_id",
    AUTO_MIGRATE_ACCOUNTS = "auto_migrate_accounts",
    PUBLIC_URL = "public_url",
    IMGLY_LICENSE = "imgly_license",
    PENDO_SECRET = "pendo_secret",
    TWILIO_SID = "twilio_sid",
    TWILIO_MSID = "twilio_msid",
    TWILIO_TOKEN = "twilio_token",
    TWILIO_FROM = "twilio_from",
    BITLY_TOKEN = "bitly_token",
    BITLY_DOMAIN = "bitly_domain",
    FB_DYNAMICLINK_KEY = "fb_dynamiclink_key",
    FB_DYNAMICLINK_URI = "fb_dynamiclink_uri",
    SALESFORCE_CHECKIN_TABLE = "salesforce_checkin_table",
    SLACK_BOT_TOKEN = "slack_bot_token",
    SUPERADMINS_ALLOWLIST = "superadmins_allowlist",
    DISABLED_FEATURES = "disabled_features",
    CUSTOMER_SMS_RESPONSE_EMAIL = "customer_sms_response_email",
    ENABLE_AUDIT = "enable_audit",
    ACTIVE_BETA_PROGRAMS = "active_beta_programs",
    CLOUD_SQL_CREDENTIALS = "cloud_sql_credentials",
    DEFAULT_ENABLE_AUTO_POSTING = "default_enable_auto_posting",
    TELNYX_KEY = "telnyx_key",
    TELNYX_NOTIFICATIONS_FROM = "telnyx_notifications_from",
    TELNYX_DEFAULT_FROM = "telnyx_default_from",
    PLUGIN_IP_FILTER = "plugin_ip_filter",
    RWL_INTEGRATION_EXTERNAL_ID = "rwl_integration_external_id",
    HELPCENTER_JWT_SECRET = "helpcenter_jwt_secret",
    HELPCENTER_URL = "helpcenter_url",
    FTC_REVIEW_COMPLIANCE = "ftc_review_compliance",
    HELPCENTER_LINK_DISABLED = "helpcenter_link_disabled",
    // The below configs are for testing purposes, they're not expected to be set in production
    REVIEW_FOLLOW_UP = "review_follow_up",
    MOBILE_JWT_SECRET = "mobile_jwt_secret",
    DELETE_MISSING_GOOGLE_REVIEWS = "delete_unavailable_google_reviews",
    LOCALVIKING_API_KEY = "localviking_api_key",
    JOBBER_CLIENT_ID = "jobber_client_id",
    JOBBER_CLIENT_SECRET = "jobber_client_secret",
    ENABLE_STORY_STATUS_FOR_ALL = "enable_story_status_for_all",
    COMPANYCAM_CLIENT_SECRET = "companycam_client_secret",
    COMPANYCAM_CLIENT_ID = "companycam_client_id",
}

export type ReviewFollowUpSettings = {
    intervalSize?: number;
    intervalUnit?: string;
    startOfBusinessHour?: number;
    endOfBusinessHour?: number;
};

export default Configs;
